(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partsvolt-product-service-tutorials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.pvReady === 'true') return;
      root.dataset.pvReady = 'true';
      const dataNodes = root.querySelectorAll('[data-pv-service-tutorial-data]');
      const list = root.querySelector('[data-pv-tutorial-list]');
      const search = root.querySelector('[data-pv-tutorial-search]');
      const more = root.querySelector('[data-pv-tutorial-more]');
      const status = root.querySelector('[data-pv-tutorial-status]');
      const batchSize = Number(root.dataset.batchSize) || 20;
      const tutorials = Array.from(dataNodes).flatMap((dataNode) => {
        const payload = JSON.parse(dataNode.textContent || '{}');
        return payload.tutorials || [];
      });
      let filtered = tutorials;
      let visible = batchSize;

      const buildCard = (tutorial) => {
        const card = document.createElement('article');
        card.className = 'pv-product-tutorials__card';
        const meta = document.createElement('p');
        meta.className = 'pv-product-tutorials__meta';
        const vehicle = document.createElement('span');
        vehicle.className = 'pv-product-tutorials__vehicle';
        vehicle.textContent = tutorial.vehicle;
        const badge = document.createElement('span');
        badge.className = 'pv-product-tutorials__badge';
        badge.textContent = tutorial.direct ? root.dataset.directLabel : root.dataset.linkedLabel;
        meta.append(vehicle, badge);

        const heading = document.createElement('h3');
        const articleLink = document.createElement('a');
        articleLink.href = tutorial.url;
        articleLink.textContent = tutorial.title;
        heading.append(articleLink);

        const links = document.createElement('div');
        links.className = 'pv-product-tutorials__links';
        const tutorialLink = articleLink.cloneNode(true);
        tutorialLink.textContent = tutorial.title;
        const officialLink = document.createElement('a');
        officialLink.href = tutorial.tesla_url;
        officialLink.target = '_blank';
        officialLink.rel = 'noopener noreferrer nofollow';
        officialLink.textContent = root.dataset.officialLabel;
        links.append(tutorialLink, officialLink);
        card.append(meta, heading, links);
        return card;
      };

      const render = () => {
        list.replaceChildren(...filtered.slice(0, visible).map(buildCard));
        status.textContent = filtered.length ? `${Math.min(visible, filtered.length)} / ${filtered.length}` : root.dataset.noResults;
        more.hidden = visible >= filtered.length;
      };

      search.addEventListener('input', () => {
        const query = search.value.trim().toLocaleLowerCase();
        filtered = tutorials.filter((tutorial) => {
          const haystack = `${tutorial.title} ${tutorial.vehicle}`.toLocaleLowerCase();
          return haystack.includes(query);
        });
        visible = batchSize;
        render();
      });

      more.addEventListener('click', () => {
        visible += batchSize;
        render();
      });
      render();
    };

    document.querySelectorAll('[data-pv-service-tutorials]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pv-service-tutorials]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
